import React, { useState } from 'react'
import { Wrapper, ColDetail } from './style.css'
import { CSSTransition } from 'react-transition-group'

import Textos from '../data'
import Detail from '../../Detail'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { ChevronRightIcon } from '@primer/octicons-react'

const AllItems = ({
  allVisibles,
  comunasAfectadas,
  titulo,
  innerRef,
  triggerMapChange,
  resetMapView,
}) => {
  // console.log('oye, el allVisibles acá', allVisibles)

  const dateParser = aDate => {
    const parsedDate = Date.parse(aDate)
    return format(parsedDate, 'dd MMM yyyy', { locale: es })
  }

  const causasFormatter = causas => {
    return causas.length > 1 ? `${causas.length} Causas` : `1 Causa`
  }

  const comunasAfectadasFormatter = comunas => {
    return comunas > 1 ? `${comunas} comunas afectadas` : `Una comuna afectada`
  }

  const duration = 1000

  const [open, setOpen] = useState(false)
  const [data, setData] = useState({})

  const handleToggle = () => {
    console.log('toggling!!')
    resetMapView()
    setOpen(false)
    setTimeout(() => setData({}), 500)
  }

  const handleClick = node => {
    console.log('triggering!!', node)
    triggerMapChange(node)
    setOpen(true)
    setData(node)
  }

  return (
    <Wrapper ref={innerRef}>
      <CSSTransition in={open} timeout={duration} classNames="wrap">
        <div className="slide-wrap">
          <div className="panel">
            <h2 className="p-6 pb-0 text-2xl leading-tight font-inter">
              {titulo}
            </h2>
            <div className="p-6">
              <Textos semestre="final" />
            </div>
            <hr className="mx-6 mb-6" />
          </div>
        </div>
      </CSSTransition>
    </Wrapper>
  )
}

export default AllItems
